import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationAlertData {
  resendVerificationStatus = 0;
  resendVerificationMessage = '';
  isLoading = false;

  init() {
    this.resendVerificationStatus = 0;
    this.resendVerificationMessage = '';
    this.isLoading = false;
  }

  setSuccess(successMessage) {
    this.resendVerificationStatus = 1;
    this.resendVerificationMessage = successMessage;
  }

  setError(errorMessage) {
    this.resendVerificationStatus = -1;
    this.resendVerificationMessage = errorMessage;
  }

  setLoadingStatus(status) {
    this.isLoading = status;
  }
}
